import { render, staticRenderFns } from "./PurchasedCourseCard.vue?vue&type=template&id=0002ab42&scoped=true"
import script from "./PurchasedCourseCard.vue?vue&type=script&lang=js"
export * from "./PurchasedCourseCard.vue?vue&type=script&lang=js"
import style0 from "./PurchasedCourseCard.vue?vue&type=style&index=0&id=0002ab42&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0002ab42",
  null
  
)

export default component.exports